export enum FeedbackEnum {
  POSITIVE = "POSITIVE",
  NEGATIVE = "NEGATIVE",
}
